const MULTI_CHAIN_ADAPTERS = {
    OPENLOGIN: "openlogin",
    // WALLET_CONNECT_V1: "wallet-connect-v1",
    WALLET_CONNECT_V2: "wallet-connect-v2",
};
const EVM_ADAPTERS = Object.assign({ METAMASK: "metamask" }, MULTI_CHAIN_ADAPTERS);
const GOOGLELOGIN_ADAPTERS = {
    GOOGLE: "googlelogin",
};
const OTHER_ADAPTERS = {
    GUEST: "guest",
};
export const SUPPORTED_ADAPTERS = Object.assign(Object.assign(Object.assign({}, EVM_ADAPTERS), GOOGLELOGIN_ADAPTERS), OTHER_ADAPTERS);
//# sourceMappingURL=index.js.map